import angular from "../../../_snowpack/pkg/angular.js";
import {ActionExecutor, ApiValidationErrorType, AvatarPictureType, Calculations, DataMappersLogic, Dates, EnumerationsLogic, ExportMethod, LegalEntityType, MessageThreads, PeriodType, Translations, Validation, InvoicesLogic} from "../../../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
export class ProController {
  constructor($rootScope, proService, partnerSettings, alertService, uiHelpers, naviService, $timeout, fileService, jsonSchemaService) {
    this.proService = proService;
    this.partnerSettings = partnerSettings;
    this.alertService = alertService;
    this.uiHelpers = uiHelpers;
    this.naviService = naviService;
    this.$timeout = $timeout;
    this.fileService = fileService;
    this.jsonSchemaService = jsonSchemaService;
    this.paymentStartedWarningStartDate = Dates.getToday();
    this.paymentStartedWarningEndDate = Dates.add(this.paymentStartedWarningStartDate, -6, "month");
    this._serviceModelCustomers = [];
    this._enums = {};
    this.odataReader = {
      getJSON: (method) => {
        return this.proService.getJSON(method);
      }
    };
    this.customerSearch = {
      period: {
        periodType: PeriodType.Month,
        refDate: Dates.getToday(),
        endDate: null
      },
      isLoading: false
    };
    this.sxyTableIncludes = [
      {title: Translations.get("SALAXY.PRO.AgGridComponent.columns.displayName"), field: "ownerInfo.avatar.displayName"},
      {title: Translations.get("SALAXY.PRO.AgGridComponent.columns.email"), field: "ownerInfo.email"},
      {title: Translations.get("SALAXY.PRO.AgGridComponent.columns.telephone"), field: "ownerInfo.telephone"},
      {title: Translations.get("SALAXY.PRO.AgGridComponent.columns.latestSalaryPay"), field: "salaryDate", hozAlign: "right", formatter: (cell) => Dates.format(cell.getValue())},
      {title: Translations.get("SALAXY.PRO.AgGridComponent.columns.grossSalary"), field: "grossSalary", hozAlign: "right", formatter: "money", formatterParams: {symbol: "€", symbolAfter: true, decimal: ",", thousand: " "}},
      {title: Translations.get("SALAXY.PRO.AgGridComponent.columns.payment"), field: "payment", hozAlign: "right"},
      {
        title: "",
        formatter: (_cell, _formatterParams, _onRendered) => {
          return `<div class="text-center"><button type="button" class='btn btn-primary'>${Translations.get("SALAXY.PRO.AgGridComponent.rowActions.select")}</button></div>`;
        },
        cellClick: (e, cell) => {
          this.proService.selectId(cell.getRow().getData().id, "/settings/service-settings");
        }
      }
    ];
    this.sxyTableOptions = {selectable: false, layout: "fitColumns"};
    this.$onInit = () => {
    };
    this.proListFilter = (customer, index, array) => {
      let searchText = this.searchText;
      if (!searchText) {
        return true;
      }
      searchText = searchText.toLowerCase();
      return customer && customer.avatar && customer.avatar.sortableName && customer.avatar.sortableName.toLowerCase().indexOf(searchText) > -1 || customer && customer.identity && customer.identity.officialId && customer.identity.officialId.toLowerCase().indexOf(searchText) > -1 || customer && customer.contact && customer.contact.email && customer.contact.email.toLowerCase().indexOf(searchText) > -1 || customer && customer.id && customer.id.toLowerCase().indexOf(searchText) > -1;
    };
    this.listfields = {
      data: {isFilterable: true, isSearchable: true},
      flags: {isFilterable: true, isSearchable: true},
      messages: {isFilterable: true, isSearchable: true},
      createdAt: {isFilterable: true, isSortable: true},
      updatedAt: {isFilterable: true, isSortable: true},
      ownerId: {isFilterable: true, isSortable: true},
      startAt: {isFilterable: true, isSortable: true},
      endAt: {isFilterable: true, isSortable: true},
      grossSalary: {isFilterable: true, isSortable: true},
      payment: {isFilterable: true, isSortable: true},
      fee: {isFilterable: true, isSortable: true},
      otherId: {isFilterable: true, isSortable: true},
      salaryDate: {isFilterable: true, isSortable: true},
      logicalDate: {isFilterable: true, isSortable: true},
      status: {isFilterable: true, isSearchable: true, isSortable: true},
      backOfficeStatus: {isFilterable: true, isSearchable: true, isSortable: true},
      shortText: {isFilterable: true, isSearchable: true, isSortable: true},
      entityType: {isFilterable: true, isSearchable: true, isSortable: true},
      reference: {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/officialId": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/email": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/telephone": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/ibanNumber": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/avatar/legalEntityType": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/avatar/firstName": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/avatar/lastName": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/avatar/displayName": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/avatar/sortableName": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/avatar/initials": {isFilterable: true, isSearchable: true, isSortable: true},
      "ownerInfo/avatar/description": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/officialId": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/email": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/telephone": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/ibanNumber": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/avatar/legalEntityType": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/avatar/firstName": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/avatar/lastName": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/avatar/displayName": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/avatar/sortableName": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/avatar/initials": {isFilterable: true, isSearchable: true, isSortable: true},
      "otherPartyInfo/avatar/description": {isFilterable: true, isSearchable: true, isSortable: true}
    };
    $rootScope.$on("$locationChangeStart", () => {
      this.naviService.resolveAndSetCurrentNode();
    });
  }
  get isAuthenticated() {
    return !!this.session && this.session.isAuthorized && !!this.accounts;
  }
  get isSessionChecking() {
    return this.proService.isSessionChecking;
  }
  get isAccountReady() {
    return this.proService.checkAccountIsReady();
  }
  get isInitReady() {
    return this.proService.isInitReady;
  }
  get session() {
    return this.proService.session;
  }
  hasCfaPaymentChannels(paymentChannels) {
    return !!paymentChannels?.some((x) => InvoicesLogic.isCfa(x));
  }
  get showKyc() {
    return !!this.accounts?.some((x) => this.getKycState(x) === "missing" || this.getKycState(x) === "expired");
  }
  getKycState(account) {
    if (!this.hasCfaPaymentChannels(account?.pro?.paymentChannels)) {
      return "ignored";
    }
    if (!account.identity?.kycUpdatedAt) {
      return "missing";
    }
    if (Dates.isBefore(account.identity.kycUpdatedAt, Dates.add(Dates.getToday(), -10, "month"))) {
      return "expired";
    }
    return "valid";
  }
  getKycUpdatedAt(account) {
    return account.identity?.kycUpdatedAt;
  }
  getKycExpiresAt(account) {
    const kycUpdatedAt = account.identity?.kycUpdatedAt;
    if (!kycUpdatedAt) {
      return "";
    }
    return Dates.add(Dates.asDate(kycUpdatedAt), 12, "month");
  }
  get isCfaCustomer() {
    return !!this.accounts?.some((x) => this.hasCfaPaymentChannels(x?.pro?.paymentChannels));
  }
  get accounts() {
    return this.proService.accounts;
  }
  get path() {
    return this.proService.getNavigationPath();
  }
  get idFromPath() {
    return this.proService.getIdFromPath();
  }
  get customers() {
    const serviceModelCustomers = (this.proService.customers ?? []).filter((x) => {
      if (!this.serviceModelId) {
        return true;
      }
      return this.serviceModelId == x.serviceModelId || !x.serviceModelId && this.serviceModelId == x.partner;
    });
    this.modifyOptions(serviceModelCustomers, this._serviceModelCustomers);
    return this._serviceModelCustomers;
  }
  get account() {
    return this.proService.account;
  }
  get proAccount() {
    return this.accounts.find((x) => x.id === this.session.currentAccount.id);
  }
  get isProAccount() {
    return !this.account || !this.session?.currentAccount || this.account?.id == this.session?.currentAccount?.id;
  }
  alert(message, type = "error") {
    switch (type) {
      case "info":
        return this.alertService.addInfo(message);
      case "success":
        return this.alertService.addSuccess(message);
      case "warning":
        return this.alertService.addWarning(message);
      case "error":
      default:
        return this.alertService.addError(message);
    }
  }
  login() {
    this.proService.login();
  }
  logout() {
    this.proService.logout();
  }
  select(account, url = null) {
    const style = document.body.style;
    document.body.style = "pointer-events:none";
    const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    this.proService.setAccount(account, url).then(() => {
      document.body.style = style;
      loading.dismiss();
    });
  }
  selectId(accountId, url = null) {
    this.proService.selectId(accountId, url);
  }
  getHourlyReports() {
    return this.proService.hourlyReports;
  }
  getHourlyTotals() {
    if (!this.totalsCache) {
      const totals = this.proService.hourlyReports.reduce((r, row) => {
        r[row.account.id] = (r[row.account.id] || 0) + (row.end && row.start ? row.end - row.start : 0);
        return r;
      }, {});
      this.totalsCache = Object.keys(totals).map((key) => ({
        key,
        account: this.proService.hourlyReports.find((x) => x.account.id === key).account,
        ms: totals[key]
      }));
    }
    return this.totalsCache;
  }
  openWeb(accountId, url) {
    url = url || this.tempGetUrl(accountId);
    this.proService.getUrlWithToken(accountId, url).then((url2) => {
      window.open(url2, "_blank");
    });
  }
  tempGetUrl(accountId) {
    switch (accountId) {
      case "FI18POYK0027758495":
        return "https://test-talenom.palkkaus.fi/";
      default:
        return this.partnerSettings.settings.primarySite.previewUrl;
    }
  }
  launchCompanyWizard(accountId = null) {
    return this.proService.launchCompanyWizard(accountId);
  }
  get config() {
    return window.salaxy.config;
  }
  isInRole(role) {
    return this.proService.isInRole(role);
  }
  deleteAccount(accountId) {
    this.proService.deleteAccount(accountId);
  }
  getHideOwnAccount() {
    if ((this.proService.account || {}).id === (this.proService.session.currentAccount || {}).id) {
      return true;
    }
  }
  changeAccountPartner(accountId, serviceModelId, action = "add") {
    return this.proService.changeAccountPartner(accountId, serviceModelId, action);
  }
  getServiceModel(serviceModelId) {
    return this.proService.getServiceModels().find((x) => x.id == serviceModelId || !serviceModelId && x.id == this.session.currentAccount.id) ?? {};
  }
  get ownedPaymentChannel() {
    return this.proService.getOwnedPaymentChannel();
  }
  isIrModified(item) {
    return item.flags.some((x) => x === "modified");
  }
  isEprDelayed(item) {
    if (!item.data.firstDeliveredAt) {
      const officialDate = Dates.add(item.salaryDate, 5, "day");
      const expiresAt = Dates.addWorkdays(officialDate, 0);
      const today = Dates.asDate("today");
      return today > expiresAt;
    }
    return false;
  }
  isPsrDelayed(item) {
    if (!item.data.firstDeliveredAt) {
      const officialDate = Dates.add(Dates.add(item.logicalDate, 1, "month"), 4, "day");
      const expiresAt = Dates.addWorkdays(officialDate, 0);
      const today = Dates.asDate("today");
      return today > expiresAt;
    }
    return false;
  }
  async searchCustomers() {
    const periodResult = await this.uiHelpers.openEditDialog("views/templates/pro-customer-query-period-dialog.html", this.customerSearch.period, null);
    if (periodResult.action === "ok") {
      this.customerSearch.period = periodResult.item;
      let refDate = this.customerSearch.period.refDate;
      let periodType = this.customerSearch.period.periodType;
      let endDate = this.customerSearch.period.endDate;
      if (periodType === "all") {
        refDate = "2010-01-01";
        endDate = "2100-01-01";
        periodType = PeriodType.Custom;
      }
      refDate = Dates.asDate(refDate) || Dates.getToday();
      const prmsArr = [];
      if (periodType) {
        prmsArr.push(`periodType=${periodType}`);
      }
      if (endDate) {
        prmsArr.push(`endDate=${endDate}`);
      }
      const prms = prmsArr.join("&");
      this.customerSearch.isLoading = true;
      const queryResult = await this.proService.getJSON(`pro/customers/${refDate}${prms ? "?" + prms : ""}`);
      this.$sxyTable.data = queryResult.items;
      await this.$timeout();
      this.$sxyTable.refresh();
      this.customerSearch.isLoading = false;
    }
  }
  export(target) {
    switch (target) {
      case "csv":
        this.$sxyTable.tabulator.download("csv", "data.csv", {bom: true});
        break;
      case "xlsx":
        this.$sxyTable.tabulator.download("xlsx", "data.xlsx", {bom: true});
        break;
    }
  }
  getServiceModelEnums() {
    return this.uiHelpers.cache(this, "getServiceModelEnums", () => {
      return this.proService.getServiceModels().map((item) => {
        const avatar = item.data.icon ? {
          description: item.shortText,
          displayName: item.shortText,
          entityType: LegalEntityType.Company,
          pictureType: AvatarPictureType.Uploaded,
          url: item.data.icon || item.ownerInfo.avatar.url
        } : item.ownerInfo.avatar;
        const text = item.id == item.ownerInfo.avatar.id ? item.shortText || `${Translations.get("SALAXY.PRO.ProComponent.serviceModelEnums.defaultModel")} ${item.ownerInfo.avatar.displayName}` : item.shortText || Translations.get("SALAXY.PRO.ProComponent.serviceModelEnums.unnamed");
        return {text, value: item.id, ui: {avatar}};
      });
    }, () => this.proService.getServiceModels());
  }
  refreshCustomers() {
    return this.proService.refreshCustomers();
  }
  getCalculationsExportable($odata) {
    return {
      getExportMappers: () => DataMappersLogic.getBuiltInMappers().filter((x) => x.uri == "@salaxy/core/CalculationListItem_Pro"),
      getExportMapper: (id) => DataMappersLogic.getBuiltInMapper(id, this.jsonSchemaService.getCache()),
      exporters: this.fileService.getDefaultExporters().filter((x) => x.id == ExportMethod.FileExcel),
      list: (maxCount, notify) => $odata.exportItems(maxCount, notify),
      getSingle: () => null
    };
  }
  getFields(feature) {
    return this.uiHelpers.cache(this, "fields-" + feature, () => Object.keys(this.listfields).filter((key) => this.listfields[key][feature]).map((key) => ({
      value: key,
      text: key.replace("ownerInfo/", "Owner: ").replace("otherPartyInfo/", "Other party: ").replace("avatar/", "")
    })), () => "");
  }
  getOptions(optionInputs = {}) {
    const result = {$orderby: "updatedAt desc"};
    if (optionInputs.orderby) {
      result.$orderby = optionInputs.orderby + optionInputs.orderbyDirection;
    }
    if (optionInputs.search) {
      result.fullSearch = optionInputs.search;
    }
    return result;
  }
  getEnumValues(enumType) {
    let values = this._enums[enumType];
    if (!values) {
      values = EnumerationsLogic.getEnumMetadata(enumType).values;
      this._enums[enumType] = values;
    }
    return values;
  }
  async recommendVarma(accountSettingsListItem) {
    const customer = this.customers.find((x) => x.id == accountSettingsListItem.ownerInfo.avatar.id);
    this.uiHelpers.showAlert(customer.avatar.displayName, JSON.stringify(customer, null, " "));
    const ajax = await this.proService.getAjaxFor(customer.id);
    const messageThreads = new MessageThreads(ajax);
    const recommendationMessage = messageThreads.getBlank();
    console.log(recommendationMessage);
  }
  async executeOnList(action, list, top = null) {
    const executor = new ActionExecutor(action);
    list.forEach((item, index) => {
      if (!top || index < top) {
        item.actionResult = "waiting";
      }
    });
    let currentIx = 0;
    for await (const item of list) {
      item.actionResult = "processing...";
      try {
        const session = this.proService.getSessionFor(item.ownerId);
        const ajax = await this.proService.getAjaxFor(session.currentAccount.id);
        const calc = await new Calculations(ajax).getSingle(item.id);
        if (calc?.result) {
          const result = await executor.execute(calc, session, ajax);
          if (result) {
            item.actionResult = "done";
            if (calc.result.validation.errors?.length) {
              item.messages = calc.result.validation.errors.map(Validation.validationErrorAsMessage).concat(item.messages);
            }
          } else {
            item.actionResult = "ERROR";
            item.messages = [Validation.validationErrorAsMessage({
              msg: "Action error: " + executor.result.toString(),
              type: ApiValidationErrorType.General
            })];
          }
        } else {
          item.actionResult = "Not found";
          item.messages = [Validation.validationErrorAsMessage({
            msg: `Calc or result not found`,
            type: ApiValidationErrorType.General
          })];
        }
      } catch (ex) {
        item.actionResult = "ERROR";
        item.messages = [Validation.validationErrorAsMessage({
          msg: "Action error: " + ex.toString(),
          type: ApiValidationErrorType.General
        })];
      }
      currentIx++;
      if (top && currentIx > top - 1) {
        break;
      }
    }
    this.$timeout();
  }
  modifyOptions(source, target) {
    if (angular.equals(source, target)) {
      return;
    }
    target.splice(0, target.length);
    target.push(...source);
  }
}
ProController.$inject = [
  "$rootScope",
  "ProService",
  "PartnerSettings",
  "AlertService",
  "UiHelpers",
  "NaviService",
  "$timeout",
  "FileService",
  "JsonSchemaService"
];
